export default __webpack_public_path__ + "static/media/photo--lg--43.6ed04e16.jpg";